import React from "react";
import { useNavigate } from "react-router-dom";

export default function GiftItem({ gift }) {
  const navigate = useNavigate();

  const styles = {
    card: {
      width: "230px",
      background: "#fff",
      borderRadius: "10px",
      padding: "12px",
      margin: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      transition: "all 0.3s ease",
      cursor: "pointer",
    },
    image: {
      width: "100%",
      height: "180px",
      objectFit: "cover",
      borderRadius: "8px",
    },
    priceRow: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "8px",
      padding: "0 4px",
    },
    price: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#222",
    },
    discount: {
      background: "#e6f8e6",
      color: "#1b7a1b",
      fontSize: "14px",
      padding: "2px 10px",
      borderRadius: "12px",
      fontWeight: "600",
    },
    name: {
      marginTop: "10px",
      fontSize: "15px",
      fontWeight: 500,
      color: "#444",
      textAlign: "center",
    },
  };

  return (
    <div
      style={styles.card}
      onClick={() => navigate(`/product/${gift.id}`)}
    >
      <img src={gift.imageUrl} alt={gift.name} style={styles.image} />

      <div style={styles.priceRow}>
        <span style={styles.price}>₹{gift.price}</span>
        <span style={styles.discount}>{gift.discount}% OFF</span>
      </div>

      <div style={styles.name}>{gift.name}</div>
    </div>
  );
}
